module.exports = __webpack_public_path__ + "static/media/tournament-thumb-8ball.4a82a4a8.png";